
export const SET_TAB = 'SET_TAB' as const;
export const SET_DRAWER_VISIBILITY = 'SET_DRAWER_VISIBILITY' as const;